<template>
    <div v-if="this.window_width > 600">
    <b-jumbotron style="background-color: #125697; margin-bottom:-5px;"
                     header-level="5">
            <p class="lead" style="margin-bottom:75px;">
                <b-img class="logo logo-size" src="https://forman-realty-group.imgix.net/LogoFJA-01.png"
                       href="/"></b-img>
            </p>
        </b-jumbotron>
    </div>
</template>

<script>
export default {
    name: "JumbotronComponent",
    data() {
        return {
            window: {
                width: 0,
                height: 0
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    },
    computed: {
        window_width() {
            return this.window.width;
        },
    },
}
</script>

<style scoped>

</style>
